import styled from 'styled-components'
// themes
import { colors } from 'themes'
// utils
import { size } from 'polished'

export const CardWrapper = styled.div<{
  width: number
  height: number
  hasLink: boolean
}>`
  padding: 18px;
  overflow: hidden;
  cursor: ${({ hasLink }) => (hasLink ? 'pointer' : 'default')};
  border-radius: 6px;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
  height: ${({ height }) => height}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${colors.white100};

  svg {
    ${size('40px')};
  }
`

export const CardTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
`

export const CardValue = styled.div`
  font-size: 40px;
  font-weight: 600;
  height: 40px;
  display: flex;
  align-items: center;
`
